import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import { APIErrorResponse, QuotationPaymentTerm } from '@/types'

export const usePostQuotationPaymentTermsGenerate = (
  quotationId: number
): UseMutationResult<QuotationPaymentTerm[], APIErrorResponse, void> => {
  const client = useApiClient()

  return useMutation(() =>
    client
      .post(`/quotations/${quotationId}/payment_terms/generate/`)
      .then(unwrapResponse)
      .catch(unwrapErrorResponse)
  )
}
